<template>
    <div
        :class="[
            'o-m-header-main',
            'm-header-main',
            {'m-header-main--compact': isLandscape && !extras}
        ]"
    >
        <router-link
            v-if="isShowLogo"
            tag="button"
            role="button"
            :to="redirectToHome"
            class="m-header__button"
            name="redirectToHome"
            :aria-label="ariaLabelToHome"
        >
            <svg-icon
                original
                name="icons/logo_mobile"
                class="m-header__logo"
            />
        </router-link>
        <div
            v-if="isButtons"
            class="m-header__buttons"
        >
            <router-link
                type="button"
                role="button"
                tag="button"
                class="m-header__button m-header__button--search"
                name="redirectToSearch"
                :aria-label="ariaLabelToSearch"
                :to="redirectToSearch"
            >
                <svg-icon
                    original
                    name="icons/search_mobile"
                    class="m-header__icon--search"
                />
            </router-link>
            <button
                type="button"
                role="button"
                class="m-header__button m-header__button--hamburger"
                name="handleMenu"
                :aria-label="ariaLabelHandleMenu"
                @click="handleMenu"
            >
                <svg-icon
                    original
                    name="icons/hamburger"
                    class="m-header__icon--hamburger"
                />
            </button>
        </div>
        <AMBackButton
            v-else
            :text="$t('ui.close')"
            @onClick="handleClose"
        />
        <div
            v-if="extras"
            class="m-header-main__overlay"
            @click.self="handleMenu"
        >
            <component
                :is="defineComponents"
                :extras="extrasMainCategories"
                @onMenuClick="handleMenuClick"
                @localeChanged="handleMenu"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import OMLanguages from '../../unique-organisms/o-m-languages/o-m-languages';
import OMainCategoryMenu from '../../organisms/o-main-category-menu/o-main-category-menu';

import {
    MOBILE_ROOT,
    MOBILE_SEARCHBAR
} from '../../../utils/constants/pages';

export default {
    name: 'OMHeaderMain',
    components: {
        OMLanguages,
        AMBackButton,
        OMainCategoryMenu
    },
    props: {
        ariaLabelToHome: {
            type: String,
            default: 'Redirect to home'
        },
        ariaLabelToSearch: {
            type: String,
            default: 'To search'
        },
        ariaLabelHandleMenu: {
            type: String,
            default: 'Handle menu'
        }
    },
    data() {
        return {
            extras: false,
            currentUnit: 'menu',
            units: {
                menu: 'OMainCategoryMenu',
                languages: 'OMLanguages'
            }
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale,
            isLandscape: state => state.landscape,
            languages: state => state.map.meta.languages
        }),
        isButtons() {
            return [MOBILE_ROOT].includes(this.$route.name);
        },
        isShowLogo() {
            return this.isLandscape ? this.extras : true;
        },
        defineComponents() {
            return this.units[this.currentUnit];
        },
        redirectToHome() {
            return {
                name: MOBILE_ROOT
            }
        },
        redirectToSearch() {
            return {
                name: 'mobile.searchbar',
                params: {
                    from: this.$route.name.split('.')[1]
                }
            }
        },
        extrasMainCategories() {
            return [
                {
                    name: this.locale,
                    icon: `locales/${this.locale}`,
                    description: false
                }
            ]
        }
    },
    watch: {
        '$route'() {
            this.extras = false;
        }
    },
    methods: {
        handleMenu() {
            this.extras = !this.extras;
            this.currentUnit = 'menu';
        },
        handleMenuClick(data) {
            if (this.languages.includes(data)) this.currentUnit = 'languages';
            else if (data === this.$route.name.split('.')[1]) {
                this.extras = false;
            } else {
                const params = {
                    name: `mobile.${data}`
                };
                this.$router.push(params);
            }
        },
        handleClose() {
            this.$emit('onClose', true);
        }
    }
}
</script>

<style lang="scss">
@import "o-m-header-main";
</style>
